// Collection of all admin routes

import { apiRoutes } from "./api/router";
import { courseAdminRoutes } from "./course/routes";
import { eventAdminRoutes } from "./events/routes";
import { learningRoutes } from "./learningmanagement/routes";
import { sharedCourseRoutes } from "./shared-courses/routes";
import { systemConfigurationRoutes } from "./system-configuration/routes";
import { testManagementRoutes } from "./test-management/routes";
import { userStateRoutes } from "./user-state/routes";
import { userAdminRoutes } from "./users/routes";

export const adminRoutes = [
  ...eventAdminRoutes,
  ...learningRoutes,
  ...courseAdminRoutes,
  ...sharedCourseRoutes,
  ...userAdminRoutes,
  ...apiRoutes,
  ...systemConfigurationRoutes,
  ...userStateRoutes,
  ...testManagementRoutes,
];
